
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { maska } from 'maska'
import { IDateRangePicker, IRichMenu, IRichMenuAudienceSetting, IUser } from '@/utils/types'
import AudienceOrNotSetting from '@/components/story/common/selectors/AudienceOrNotSettingV2.vue'
import AudieneceDndList from '@/components/story/common/selectors/AudieneceDndList.vue'
import UserAvatar from '@/components/user/UserAvatar.vue'
import { DatetimeUtils } from '@/utils/datetime'
import { ACTION_AUDIENCE } from '@/store/actions'
import CLoading from '@/components/common/ui/CLoading.vue'
import { constant } from '@/utils/constants'

@Options({
  components: { CLoading, UserAvatar, AudieneceDndList, AudienceOrNotSetting },
  directives: { maska },
  emits: ['update:modelValue', 'setDefaultRichMenu'],
})
export default class RichMenuConditionSetting extends Vue {
  @Prop()
  modelValue!: IRichMenuAudienceSetting

  @Prop()
  defaultRichMenu!: IRichMenu

  @Prop({ default: false })
  isTestMode = false

  @Prop()
  appId!: string

  loading = false
  tabs = 'condition'
  dateRange: IDateRangePicker = {
    startDate: '',
    endDate: '',
  }

  totalUsers = 0
  users: IUser[] = []
  pagination = {
    sortBy: 'updated_at',
    descending: true,
    page: 1,
    rowsPerPage: constant.ROW_PER_PAGE,
    rowsNumber: 10,
  }

  get value() {
    return this.modelValue
  }

  set value(value: IRichMenuAudienceSetting) {
    this.$emit('update:modelValue', value)
  }

  get isDefaultSelected() {
    return this.value._id === this.defaultRichMenu._id
  }

  get audienceNotSize() {
    if (this.value.audience && this.value.audience.audience_not) {
      return this.value.audience.audience_not.reduce((sum, item) => {
        return sum + (item.audience_size ?? 0)
      }, 0)
    }
    return 0
  }

  get rowPerPageOptions() {
    return constant.ROW_PER_PAGE_OPTIONS
  }

  setDefault() {
    this.$emit('setDefaultRichMenu', this.value._id)
  }

  handleLoading(val) {
    console.log(val)
  }

  onProfileUrl(data) {
    // Construct the URL as a string for direct navigation
    return this.$router.resolve({
      name: 'app_line_user_profile',
      params: {
        app_id: this.appId,
        user_id: data.user_id,
        uid: data._id,
        from_date: DatetimeUtils.formatDate(this.dateRange.startDate),
        to_date: DatetimeUtils.formatDate(this.dateRange.endDate),
        is_test_mode: this.isTestMode.toString(),
      },
    }).href
  }

  getUserInfo(display_name, picture_url) {
    const u: IUser = {
      photo_url: picture_url,
      display_name: display_name,
    }
    return u
  }

  async onUserTabClick() {
    setTimeout(() => {
      this.$refs.tableRef.requestServerInteraction()
    }, 100)
  }

  async onRequest(props) {
    const { page, rowsPerPage, sortBy, descending } = props.pagination
    const filter = props.filter
    this.loading = true
    const returnedData = await this.fetchFromServer(page, rowsPerPage, filter, sortBy, descending)
    if (returnedData) {
      console.log(returnedData)
      // eslint-disable-next-line
      const items: [] = returnedData['items']
      this.users.splice(0, this.users.length, ...items)
      // eslint-disable-next-line
      this.pagination.rowsNumber = returnedData['total_items']
      // eslint-disable-next-line
      this.totalUsers = returnedData['total_items']
    }
    this.pagination.page = page
    this.pagination.rowsPerPage = rowsPerPage
    this.pagination.sortBy = sortBy
    this.pagination.descending = descending

    this.loading = false
  }

  async fetchFromServer(page, rowsPerPage, filter, sortBy, descending) {
    const items = await this.$store.dispatch(ACTION_AUDIENCE.GET_USERS_BY_AUDIENCE_OR_NOT, {
      app_id: this.appId,
      is_test_mode: this.isTestMode,
      audience_or: this.value.audience?.audience_or ?? [],
      audience_not: this.value.audience?.audience_not ?? [],
      filter: {
        page: page,
        per_page: rowsPerPage,
        filter: filter,
        sort_by: sortBy,
        descending: descending,
      },
    })

    return items
  }

  @Watch('value', { immediate: true })
  onValueChange() {
    this.tabs = 'condition'
  }
}
